import { Quote } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Da quando ci affidiamo a Clario le aree comuni del condominio sono sempre impeccabili. Il referente unico ha semplificato tutto.",
    name: "Andrea",
    role: "Amministratore di condominio, Torino",
  },
  {
    quote:
      "Squadre puntuali prima dell'apertura degli uffici e report digitale dopo ogni intervento. Professionalità rara nel settore.",
    name: "Elena",
    role: "Office Manager, Milano",
  },
  {
    quote:
      "Hanno gestito la pulizia straordinaria del nostro magazzino logistico in un solo weekend, senza fermare le operazioni.",
    name: "Luca",
    role: "Responsabile logistica, Bologna",
  },
];

const FAQS = [
  {
    q: "Intervenite davvero in tutta Italia?",
    a: "Sì. Abbiamo squadre operative in Nord, Centro e Sud Italia, isole comprese. Per le zone non coperte direttamente attiviamo partner selezionati con lo stesso capitolato qualitativo.",
  },
  {
    q: "Il sopralluogo e il preventivo sono gratuiti?",
    a: "Sempre. Il sopralluogo può avvenire in presenza o in videochiamata entro 24 ore dalla richiesta, e il preventivo è dettagliato voce per voce, senza impegno.",
  },
  {
    q: "Posso attivare un contratto periodico per il mio condominio?",
    a: "Certamente. Proponiamo canoni settimanali, bisettimanali o mensili con referente unico per l'amministratore, gestione rifiuti e reportistica digitale.",
  },
  {
    q: "Le sanificazioni rilasciano una certificazione?",
    a: "Sì. Ogni trattamento di sanificazione è eseguito con presidi medico-chirurgici registrati e si conclude con il rilascio dell'attestato di avvenuta sanificazione, in conformità ai protocolli HACCP.",
  },
  {
    q: "Il personale è assunto e assicurato?",
    a: "Tutto il personale Clario è assunto regolarmente, formato secondo il D.Lgs 81/08 e coperto da assicurazione RCT/RCO inclusa in ogni contratto.",
  },
];

const TestimonialsFaq = () => (
  <section id="recensioni" className="bg-[#F9FAFB] py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-8 lg:grid-cols-2">
      <div>
        <Reveal>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#009E5E]">
            Dicono di noi
          </span>
          <h2 className="mt-3 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
            La fiducia si misura{" "}
            <span className="font-serif-accent font-medium text-[#00B36B]">nei rinnovi</span>
          </h2>
        </Reveal>
        <div className="mt-8 space-y-5">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="rounded-[1.5rem] border border-slate-100 bg-white p-6 shadow-[0_4px_24px_rgba(15,23,42,0.05)]"
              >
                <Quote className="h-6 w-6 text-[#00B36B]" />
                <blockquote className="mt-3 text-sm leading-relaxed text-slate-700">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-4">
                  <p className="text-sm font-bold text-slate-900">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>

      <div>
        <Reveal>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#009E5E]">
            Domande frequenti
          </span>
          <h2 className="mt-3 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
            Tutto chiaro,{" "}
            <span className="font-serif-accent font-medium text-[#00B36B]">prima di iniziare</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-8 space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-slate-100 bg-white px-5 data-[state=open]:border-[#00B36B]/30"
              >
                <AccordionTrigger className="text-left text-sm font-bold text-slate-900 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default TestimonialsFaq;
